import {
  i18n as LoginPageI18n,
  LOGIN_PAGE_NS,
} from "../pages/LoginPage/i18n";
import {
  i18n as GeneralI18n,
  GENERAL_NS,
} from "./general";
import {
  i18n as RequestOtpI18n,
  REQUEST_OTP_NS,
} from "../pages/LoginPage/RequestOTP/i18n";
import {
  i18n as DialogPromptI18n,
  DIALOG_PROMPT_NS,
} from "../components/DialogPrompt/i18n";

export const DEFAULT_NS = "translation";

export const resources = {
  en: {
    [DEFAULT_NS]: {},

    [GENERAL_NS]: GeneralI18n.en,
    [LOGIN_PAGE_NS]: LoginPageI18n.en,
    [REQUEST_OTP_NS]: RequestOtpI18n.en,
    [DIALOG_PROMPT_NS]: DialogPromptI18n.en,
  },
};
